'use client';
import React from 'react';
import Typography from '@/components/shared/typography/typography.component';
import { GreenInfo } from '../../../../public/Images';
import SylndrButton from '../Button/button-styled.component';
import Link from '@/components/WrappedLink';
import { useAnalytics } from '@/integrations';
import { useTranslation, useAppDispatch } from '@/hook';
import { AllowedVehicleBookingTypes, DisplayedCarInfoInterface } from '@/types';
import Image from 'next/image';
import colors from '@/theme/colors.module.scss';
import { NEXT_APP_MAINTENANCE_DISABLE_BOOKING } from '@/constants';
import { toggleLoading } from '@/redux/reducers/checkoutReducer';

const ReserveSeeNotify = ({
    isDesktop,
    carInfo,
    lang,
    setNotifyModal,
    seeCarButtonClicked,
    showTip,
    desktTopHeight = '',
}: {
    carInfo: DisplayedCarInfoInterface;
    isDesktop: boolean;
    lang: string;
    setNotifyModal: React.Dispatch<React.SetStateAction<boolean>>;
    seeCarButtonClicked: () => void;
    showTip: boolean;
    desktTopHeight?: string;
}) => {
    const { trackEvent } = useAnalytics();
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();

    return (
        <>
            <>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        height: isDesktop
                            ? desktTopHeight
                                ? desktTopHeight
                                : '60px'
                            : '50px',
                        minHeight: isDesktop
                            ? desktTopHeight
                                ? desktTopHeight
                                : '60px'
                            : '50px',
                    }}
                >
                    {carInfo?.bookingType !==
                        AllowedVehicleBookingTypes.SEE_ONLY &&
                        (carInfo.isReserved ? (
                            <button
                                style={{
                                    width: '100%',
                                    borderColor: colors.gray300,
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    borderWidth: '1px',
                                    height: isDesktop
                                        ? desktTopHeight
                                            ? desktTopHeight
                                            : '60px'
                                        : '50px',
                                    minHeight: isDesktop
                                        ? desktTopHeight
                                            ? desktTopHeight
                                            : '60px'
                                        : '50px',
                                    outline: 'none',
                                    border: ` 1px solid ${colors.gray300}`,
                                }}
                                onClick={() => setNotifyModal(true)}
                            >
                                <Typography
                                    variant="body1Medium"
                                    style={{ color: 'black' }}
                                >
                                    {t('Notify Me')}
                                </Typography>
                            </button>
                        ) : (
                            carInfo.id && (
                                <Link
                                    href={`/${lang}/car-details/${carInfo.id}/checkout/reserve`}
                                    style={{
                                        textDecoration: 'none',
                                        width: '100%',
                                        height: '100%',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <SylndrButton
                                        onClick={() => {
                                            trackEvent('Action: Reserve Car', {
                                                carName: carInfo.carName,
                                                newlyAdded:
                                                    carInfo.isNewlyAdded &&
                                                    !(
                                                        carInfo.isReserved ||
                                                        carInfo.isPurchaseInProgress
                                                    ),
                                                status: carInfo.isPurchaseInProgress
                                                    ? 'Being Sold'
                                                    : carInfo.isReserved
                                                    ? 'Reserved'
                                                    : 'Not Reserved',
                                            });
                                            dispatch(toggleLoading(false));
                                        }}
                                        variant={'primary'}
                                        disabled={
                                            carInfo?.isReserved ||
                                            NEXT_APP_MAINTENANCE_DISABLE_BOOKING
                                        }
                                    >
                                        <Typography variant="body1SemiBold">
                                            {t('reserve car')}
                                        </Typography>
                                    </SylndrButton>
                                </Link>
                            )
                        ))}

                    {carInfo?.bookingType !==
                        AllowedVehicleBookingTypes.RESERVE_ONLY &&
                        carInfo?.id && (
                            <Link
                                href={`/${i18n.language}/car-details/${carInfo?.id}/checkout/see`}
                                style={{
                                    textDecoration: 'none',
                                    width: '100%',
                                    height: '100%',
                                    cursor: 'pointer',
                                }}
                            >
                                <SylndrButton
                                    onClick={() => {
                                        trackEvent('Action: Book Visit', {
                                            carName: carInfo.carName,
                                            newlyAdded:
                                                carInfo.isNewlyAdded &&
                                                !(
                                                    carInfo.isReserved ||
                                                    carInfo.isPurchaseInProgress
                                                ),
                                            status: carInfo.isPurchaseInProgress
                                                ? 'Being Sold'
                                                : carInfo.isReserved
                                                ? 'Reserved'
                                                : 'Not Reserved',
                                        });
                                        seeCarButtonClicked();
                                        dispatch(toggleLoading(false));
                                    }}
                                    disabled={
                                        NEXT_APP_MAINTENANCE_DISABLE_BOOKING
                                    }
                                    variant={'secondary'}
                                >
                                    <Typography variant="body1SemiBold">
                                        {t('See Car')}
                                    </Typography>
                                </SylndrButton>
                            </Link>
                        )}
                </div>
                {!carInfo?.isPurchaseInProgress &&
                carInfo?.isReserved &&
                carInfo?.bookingType !== AllowedVehicleBookingTypes.SEE_ONLY &&
                showTip ? (
                    <div
                        style={{
                            display: 'flex',
                            padding: '10px',
                            backgroundColor: colors.success50,
                            borderRadius: '8px',
                            gap: '6px',
                            alignItems: 'flex-start',
                            alignContent: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Image
                            src={GreenInfo}
                            alt="GreenInfo"
                            width={20}
                            height={20}
                        />
                        <Typography
                            variant="captionMedium"
                            style={{
                                color: colors.success600,
                            }}
                        >
                            {t(
                                'Clicking on Notify Me will send you a message once the the car is open for reservation again'
                            )}
                        </Typography>
                    </div>
                ) : null}
            </>
        </>
    );
};

export default ReserveSeeNotify;
